<template>
  <div class="extension-panel">
    <div class="link-panel">
      <label :class="['data-description', 'link-label', { ['error-label']: !validLink }]">full url</label>
      <input 
          :class="['link-field', { error: !validLink } ]"
          type="text" 
          name="external_url"
          v-model="externalUrl"
          @input.passive="delayUpdate">
      <div class="instructions">include http:// or https://</div>
      <span class="error-label" v-if="!validLink">any link url must be present and include http:// or https://</span>
      <div v-if="previousUrls && previousUrls.length" class="previous-urls">
        <label class="text-center">previously used urls</label>
        <div v-for="(url, index) in previousUrls" :key="index" class="checkbox-row">
          <label class="container" :for="`link-${index}`">
            <span class="label-name">{{ shortenLink(url) }}</span>
            <input 
                type="checkbox"
                :value="url" 
                :id="`link-${index}`"
                :checked="url === externalUrl"
                @click="togglePreviousUrls">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="cancel-extension" @click="$emit('setExtension', 0)">cancel</div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Modal from '../shared/Modal'

  export default {
    props: {
      messageModuleName: String,
    },

    components:{
      Modal
    },

    data() {
      return {
        delayedUpdate: null,
        externalUrl: '',
        validLink: false,
      }
    },

    methods: {
      delayUpdate() {
        clearTimeout(this.delayedUpdate)
        this.delayedUpdate = setTimeout(() => this.setExternalUrl(), 500)
      },

      setExternalUrl() {
        if (this.externalUrl) { this.externalUrl = this.externalUrl.replace(/\s+/g, '') }
        this.validateUrl()
        if (this.validLink) { 
          this.$emit('passExtensionData', { external_url: this.externalUrl }) 
        }
      },

      togglePreviousUrls(event) {
        if (event.target.checked) {
          this.externalUrl = event.target.value
          this.setExternalUrl()
        } else {
          this.externalUrl = ''
          this.validateUrl()
        }
      },

      validateUrl() {
        this.validLink = this.externalUrl?.length > 1 && /(http(s?)):\/\//gi.test(this.externalUrl)
        this.$emit('validAnyLink', this.validLink)
      },

      shortenLink(url) {
        if (url) { return url.length > 25 ? url.slice(8, 24) + '...' : url.slice(8, url.length -1) }
      }
    },

    mounted() {
      this.externalUrl = this.externalLink 
      this.validateUrl()
    },

    computed: {
      previousUrls: function () {
        const merchant = this.currentMerchant
        return this.isCampaign ? merchant?.campaign_previous_urls : merchant?.auto_campaign_previous_urls
      },

      ...mapState({
        currentMerchant (state) { return state.currentMerchant },
        externalLink (state) {  return state[this.messageModuleName]?.externalUrl },
        isCampaign (state, getters) { return getters[`${this.messageModuleName}/isCampaign`] }
      }),
    },
  }
</script>